import ApiService from '@/services/ApiService';
import store from '@/store';
import Vue from 'vue';
export default {
  getAll() {
    return ApiService().get('/user/list');
  },
  add(staff) {
    return ApiService().post('/admin/user/add', staff, true);
  },
  setStaffStation(staffId, station) {
    return ApiService()
      .put('/user/set-staff-station', { userIds: [staffId], station });
  },
  
};
